import { render, staticRenderFns } from "./NewAssetLibrary.vue?vue&type=template&id=2a294d44"
import script from "./NewAssetLibrary.vue?vue&type=script&lang=js"
export * from "./NewAssetLibrary.vue?vue&type=script&lang=js"
import style0 from "./NewAssetLibrary.vue?vue&type=style&index=0&id=2a294d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports